<template>
    <tailwind-layout title="User Payroll Income">
        <template #header>
            <div class="px-4 sm:px-6 lg:px-8 mx-auto hidden lg:flex justify-between items-center"><!-- Block for lg and larger -->
                <div class="flex flex-col">
                    <h1 class="font-semibold text-2xl leading-tight">User Payroll Income</h1>
                </div>
            </div>

            <div class="mb-3 px-6 lg:px-8 mx-auto flex flex-col lg:hidden"><!-- Block for sm, md, lg (buttons will stack on smaller screens) -->
                <div class="flex justify-between items-start md:items-center">
                    <div class="flex flex-col">
                        <h1 class="font-semibold text-2xl leading-tight">User Payroll Income</h1>
                    </div>
                </div>
            </div>
        </template>

        <div class="rounded-md lg:shadow shadow-none overflow-x-auto">
                <div class="flex flex-col">
                    <div class="overflow-x-auto">
                        <div class="align-middle inline-block min-w-full">
                            <div class="shadow overflow-hidden lg:border">
                                <table class="min-w-full divide-y divide-gray-300">
                                    <thead class="bg-blue-50">
                                    <tr>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Institution Name
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Employee Name
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Employer Name
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Net Pay (Current)
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Pay Date
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Pay Frequency
                                        </th>
                                        <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">
                                            Download Document
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="item in response.items" :key="item.item_id" class="bg-gray-50 border-b hover:bg-yellow-50 hover:cursor-pointer">
                                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            {{item.institution_name}}
                                        </td>
                                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            {{item.payroll_income[0]?.pay_stubs[0]?.employee?.name || 'N/A'}}
                                        </td>
                                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            {{ item.payroll_income[0]?.pay_stubs[0]?.employer?.name || 'N/A' }}
                                        </td>
                                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            {{ item.payroll_income[0]?.pay_stubs[0]?.net_pay.current_amount ? `$${item.payroll_income[0].pay_stubs[0].net_pay.current_amount}` : 'N/A' }}
                                        </td>
                                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            {{ formatDate(item.payroll_income[0]?.pay_stubs[0]?.pay_period_details.pay_date) }}
                                        </td>
                                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            {{ item.payroll_income[0]?.pay_stubs[0]?.pay_period_details.pay_frequency || 'N/A' }}
                                        </td>
                                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            <button v-if="item.payroll_income[0]?.pay_stubs[0]?.document_metadata.download_url" @click="downloadFile(item.payroll_income[0]?.pay_stubs[0]?.document_metadata.download_url)" class="text-blue-500 hover:underline">Download</button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <full-page-loader v-if="isLoader"></full-page-loader>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import Pagination from '@/Shared/Pagination.vue'
import FullPageLoader from "@/Shared/FullPageLoader.vue";
import NavLink from "@/Jetstream/NavLink.vue";
import Button from "@/Jetstream/Button.vue";

export default {
    components: {
        Button,
        NavLink,
        FullPageLoader,
        Icon,
        Pagination,
        TailwindLayout,
    },
    props: {
        response: Object,
    },
    data() {
        return {
            isLoader: false,
        }
    },
    watch: {

    },
    methods: {
        downloadFile(url) {
            window.open(url, '_blank');
            location.reload();
        },

        formatDate(dateString) {
            if (!dateString) return 'N/A';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US'); // formats as m/d/yyyy
        }
    },
}
</script>
